import { Injectable } from "@angular/core";
import { Transition } from "@uirouter/core";
import { PagedModel } from "src/app/model/common/paged.model";

@Injectable()
export class PagingHelpersService {

    public generatePagingModel = (transition: Transition): PagedModel => {
        const { page, limit, searchBy, orderBy, ascending, type, status } = transition?.params<{ 
            page: number, 
            limit: number, 
            searchBy: string, 
            orderBy: string, 
            ascending: string, 
            type: number, 
            status: number
        }>?.() ?? {};

        const adjustedPage = page ?? 1;
        const adjustedLimit = limit ?? 20;

        return {
            offset: (adjustedPage - 1) * adjustedLimit,
            type,
            limit: adjustedLimit,
            ascending: ascending === 'true',
            orderBy,
            searchBy,
            status
        }
    }

    public toArrayParam = <T>(param: T | undefined | null): T[] => {
        return (param === undefined || param === null) ? [] : 
            (Array.isArray(param) ? 
                param :
                [param]
            );
    }
}